import React, { useState } from 'react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from './auth.jsx'
import { useConfig } from './config.jsx'
import { NotificationsBell } from './lib.jsx'

const COLLAPSE_KEY = 'gpdf_sidebar_collapsed'

export default function Layout() {
  const { user, logout } = useAuth()
  const cfg = useConfig()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(COLLAPSE_KEY) === '1')

  const toggleCollapsed = () => {
    setCollapsed(c => {
      localStorage.setItem(COLLAPSE_KEY, c ? '0' : '1')
      return !c
    })
  }

  const item = (to, icon, label, end) => (
    <NavLink key={to} to={to} end={end} onClick={() => setOpen(false)} title={collapsed ? label : undefined}
      className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
      <span className="ic">{icon}</span><span className="lbl">{label}</span>
    </NavLink>
  )

  return (
    <div className={`app ${collapsed ? 'sidebar-collapsed' : ''}`}>
      <button className="menu-btn" aria-label="Menu" onClick={() => setOpen(o => !o)}>☰</button>
      <div className={`nav-overlay ${open ? 'show' : ''}`} onClick={() => setOpen(false)} />
      <aside className={`sidebar ${open ? 'open' : ''} ${collapsed ? 'collapsed' : ''}`}>
        <button className="sidebar-collapse-btn" title={collapsed ? 'Rozwiń menu' : 'Zwiń menu'} onClick={toggleCollapsed}>
          {collapsed ? '›' : '‹'}
        </button>
        <div className="brand"><div className="logo">G</div><b>generator<span>PDF</span></b></div>

        <div className="nav-label">Moje projekty</div>
        {item('/', '▦', 'Projekty', true)}

        {(cfg.features.billing || cfg.features.multi_organization) && (
          <>
            <div className="nav-label">Konto</div>
            {cfg.features.billing && item('/billing', '💳', 'Płatności')}
            {cfg.features.multi_organization && item('/organizations', '👥', 'Organizacje')}
          </>
        )}

        {user?.role === 'admin' && (
          <>
            <div className="nav-label">Panel admina</div>
            {item('/admin/templates', '⌘', 'Szablony')}
            {item('/admin/projects', '☰', 'Projekty użytkowników')}
            {item('/admin/jobs', '⏱', 'Zadania')}
            {cfg.features.billing && item('/admin/billing/plans', '💳', 'Plany')}
            {item('/admin/settings', '⚙', 'Ustawienia')}
          </>
        )}

        <div className="spacer" />
        {cfg.features.notifications && <NotificationsBell />}
        <div className="user-box">
          <div className="who">
            <div className="avatar-dot">{(user?.username || '?')[0]?.toUpperCase()}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 13 }}>{user?.username}</div>
              <span className={`role-tag ${user?.role === 'admin' ? 'role-admin' : ''}`}>{user?.role}</span>
            </div>
          </div>
          <button className="btn btn-ghost btn-sm" style={{ width: '100%', marginTop: 10 }}
            onClick={() => { logout(); navigate('/login') }}><span className="lbl">Wyloguj</span></button>
        </div>
      </aside>
      <main className="main"><Outlet /></main>
    </div>
  )
}
